<div class="bg-grey-100 p-4 rounded-lg shadow">
<h2 class="mb-4">News (Demo)</h2>
<div class="p-4 border rounded-lg shadow">
    <h3 class="text-lg font-semibold">Other Component</h3>
    <p>Dies ist eine andere Aktivitäts-Komponente.</p>
  </div>
</div>